// extracted by mini-css-extract-plugin
export var active = "_4n-7";
export var container = "_4n-0";
export var evenWidth = "_4n-4";
export var large = "_4n-5";
export var outlet = "_4n-8";
export var slide = "_4n-2";
export var small = "_4n-6";
export var tab = "_4n-3";
export var tabs = "_4n-1";